import * as React from "react";
import { Select, } from "uxp/components";
import { IUIPropertyDefinition } from "../common";
import { Property, PropertyContainer, PropertyContainerTitle, PropertyGroup, PropertyTitle } from "./common";
import { $L } from '../../../localize';

export function VerticalAlignmentProperty(widgetProps: string): IUIPropertyDefinition<string> {
    return {
        defaults: widgetProps,
        render: (props) => {
            return <>
                {
                    <PropertyContainer>
                        <PropertyContainerTitle>{$L('widgetdesigner.props.box-properties', 'Box Properties')}</PropertyContainerTitle>
                        <PropertyGroup>
                            <Property>
                                <PropertyTitle>{$L('widgetdesigner.props.vertical-alignment', 'Vertical Alignment')}</PropertyTitle>
                                <Select
                                    options={[{ name: "start" }, { name: "center" }, { name: "end" }]}
                                    selected={props.uiProps}
                                    onChange={s => props.onChange(s)}
                                    labelField="name"
                                    valueField="name"
                                />
                            </Property>
                        </PropertyGroup>
                    </PropertyContainer>
                }
            </>
        }
    };
}
